import React, {useEffect, useState} from "react";
import {Redirect, Route, Switch, useHistory} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {privateRoutes, publicRoutes} from "./routes";
import {routeNames} from "../shared/router/routeNames";
import {authModel} from "../entities/auth";
import {apiInstance} from "../shared/api/api";
import {getAccessToken, startImpersonation} from "../shared/lib/session";

// «Смотреть как»: /impersonate#<code> from the users section; the code becomes this tab's session
const takeImpersonationCode = async () => {
  if (window.location.pathname !== '/impersonate') return false
  const code = window.location.hash.slice(1)
  window.history.replaceState(null, '', '/admin')
  if (!code) return false
  try {
    const {data} = await apiInstance.post('auth/impersonate', {code})
    startImpersonation(data.accessToken, data.refreshToken)
    return true
  } catch (err) {
    alert(err?.response?.data?.errors?.message || 'Не удалось открыть: попробуйте «Смотреть как» ещё раз')
    window.close()
    return false
  }
}


export const AppRouter = observer(() => {
  const [isInitApp, setInitApp] = useState(false)
  const [pageUrl] = useState(window.location.pathname === '/impersonate' ? '/admin' : window.location.pathname)
  // the query of the opened address (?complex= of «Шахматка») is kept when the session is checked
  const [pageSearch] = useState(window.location.search)
  const history = useHistory()

  useEffect(() => {
    async function authUser() {
      await takeImpersonationCode()
      const isUserHaveToken = getAccessToken()
      if (isUserHaveToken) {
        // the session's rights; a token of someone without panel sections (an agent's) is dropped
        const access = await authModel.loadAccess()
        if (access === 'ok') {
          authModel.setAuth(true)
          history.push(pageUrl === routeNames.LOGIN ? routeNames.ADMIN : `${pageUrl}${pageSearch}`)
        } else if (access === 'denied') {
          authModel.logout()
        }
      }
      setInitApp(true)
    }
    authUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isInitApp) {
    return null
  }

  if (authModel.isAuth) {
    return (
      <Switch>
        {privateRoutes.map(({ path, component, exact }) => (
          <Route path={path} exact={exact} component={component} key={path} />
        ))}
        <Redirect exact to={routeNames.ADMIN} />
      </Switch>
    )
  }

  return (
    <Switch>
      {publicRoutes.map(({ path, component, exact }) => {
        return <Route path={path} component={component} exact={exact} key={path} />;
      })}
      <Redirect exact to={routeNames.LOGIN} />
    </Switch>
  )
})
